import React from "react";
import moment from "moment";
import WeightReportTable, { formatPercentage } from "./weightReportTable";

const gainColor = (value) => {
    if (value === null || value === undefined) return undefined;
    return value < 0 ? "#d32f2f" : value > 0 ? "#2e7d32" : undefined;
};

export default class ComponentToPrint extends React.Component {
    render() {
        const { reportData, searchData, toDateGain } = this.props;

        return (
            <div>
                <h6>Field Factory Checkroll Weight Report</h6>

                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b>{searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b>{searchData.estate}</div>
                    <div className="col"><b>Month: </b>{moment(searchData.searchMonth).format("MMMM YYYY")}</div>
                </div>

                {toDateGain && (
                    <div className="row pl-2 pb-3">
                        {[
                            { label: "FI/FA %", value: toDateGain.fifa },
                            { label: "FA/CR %", value: toDateGain.facr },
                        ].map((box, i) => (
                            <div className="col-4" key={i}>
                                <div
                                    style={{
                                        border: "1px solid #e0e0e0",
                                        borderRadius: "8px",
                                        padding: "10px 20px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <div>
                                        <div style={{ fontSize: "11px", color: "#666" }}>
                                            To-Date Gain %{toDateGain.upTo ? ` (up to ${toDateGain.upTo})` : ""}
                                        </div>
                                        <div style={{ fontSize: "13px", fontWeight: "bold", color: "#333" }}>
                                            {box.label}
                                        </div>
                                    </div>
                                    <div style={{ fontSize: "16px", fontWeight: "bold", color: gainColor(box.value) || "#555" }}>
                                        {formatPercentage(box.value)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                <WeightReportTable
                    data={reportData}
                    selectedMonth={searchData.searchMonth}
                    isPdf={true}
                />
            </div>
        );
    }
}